const SignUpType = {
  EMAIL: 'email',
  WITH_PHONE: 'with_phone',
  GOOGLE: 'google',
  FACEBOOK: 'facebook'
};

export default Object.freeze(SignUpType);
